import {
  MoreItem,
  useNavigationHeaderOptions,
} from "@/src/common/navigationHeaderOptions";
import { useLoginMoreItem } from "./useLoginMoreItem";
import { useLogoutMoreItem } from "./useLogoutMoreItem";
import { useNavigation } from "@react-navigation/native";

export function useProfileScreenNavigationHeaderOptions({
  moreItems = [],
}: {
  moreItems?: MoreItem[];
}) {
  const navigation = useNavigation();
  const getHeaderOptions = useNavigationHeaderOptions();
  const loginMoreItem = useLoginMoreItem();
  const logoutMoreItem = useLogoutMoreItem();
  return getHeaderOptions({
    type: "CLOSE",
    onClose: () => navigation.goBack(),
    title: "",
    more: [...moreItems, loginMoreItem, logoutMoreItem],
  });
}
